import React, { useState } from "react";
import { Star, MessageSquare, Send, ChevronDown, ChevronUp } from "lucide-react";

export default function ReviewCard({ review, showReplyOption = false, onReply, isExpertView = false }) {
  const [replyOpen, setReplyOpen] = useState(false);
  const [replyText, setReplyText] = useState(review.expertReply || review.expert_reply || "");
  const [saved, setSaved] = useState(!!(review.expertReply || review.expert_reply));

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("ru-RU", {
      day: "numeric",
      month: "long",
      year: "numeric"
    });
  };

  const handleSendReply = () => {
    if (!replyText.trim()) return;
    if (onReply) {
      onReply(review, replyText.trim());
    }
    setSaved(true);
    setReplyOpen(false);
  };

  return (
    <div id={`review-card_${review.author}`} className="p-5 rounded-md bg-neutral-800/30 border border-neutral-800/30">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-md bg-primary-700/30 flex items-center justify-center">
            <span className="text-primary-300 font-medium">{review.author[0]}</span>
          </div>
          <div>
            <h4 className="text-lg font-medium text-neutral-200">{review.author}</h4>
            <p className="text-lg font-extralight text-neutral-500">{formatDate(review.date)}</p>
          </div>
        </div>
        <div className="flex items-center gap-1">
          {[...Array(5)].map((_, i) => (
            <Star
              key={i}
              className={`w-4 h-4 ${
                i < review.rating
                  ? "text-warm-400 fill-warm-400"
                  : "text-neutral-700"
              }`}
            />
          ))}
        </div>
      </div>
      <p className="text-lg font-extralight text-neutral-400 leading-relaxed">
        {review.text}
      </p>

      {(review.expertReply || review.expert_reply || saved) && !replyOpen && (
        <div className="mt-4 pl-4 border-l-2 border-primary-700/40">
          <p className="text-lg font-extralight text-neutral-500 mb-1">{isExpertView ? "Ваш ответ:" : "Ответ эксперта:"}</p>
          <p className="text-lg font-extralight text-neutral-300">{replyText}</p>
        </div>
      )}

      {showReplyOption && (
        <div className="mt-4">
          {replyOpen ? (
            <div className="space-y-3">
              <textarea
                value={replyText}
                onChange={(e) => setReplyText(e.target.value)}
                rows={3}
                placeholder="Напишите ваш ответ на отзыв..."
                className="w-full px-4 py-3 rounded-md bg-neutral-800 border border-neutral-700 text-white text-lg font-extralight placeholder:text-neutral-600 focus:outline-none focus:border-primary-500 resize-none"
              />
              <div className="flex items-center gap-3">
                <button
                  onClick={handleSendReply}
                  disabled={!replyText.trim()}
                  className="flex items-center gap-2 px-4 py-2 rounded-md bg-primary-600 hover:bg-primary-500 disabled:bg-neutral-700 disabled:cursor-not-allowed text-white text-lg font-extralight transition-colors"
                >
                  <Send className="w-4 h-4" />
                  <span>Отправить</span>
                </button>
                <button
                  onClick={() => setReplyOpen(false)}
                  className="px-4 py-2 rounded-md text-neutral-400 hover:text-white text-lg font-extralight transition-colors"
                >
                  Отмена
                </button>
              </div>
            </div>
          ) : (
            <button
              onClick={() => setReplyOpen(true)}
              className="flex items-center gap-2 text-neutral-500 hover:text-primary-400 text-lg font-extralight transition-colors"
            >
              <MessageSquare className="w-4 h-4" />
              <span>{saved ? "Редактировать ответ" : "Ответить"}</span>
            </button>
          )}
        </div>
      )}
    </div>
  );
}
